import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerDayoffsHost, type DayoffsHost } from './host'
import { dayoffsModals } from './modals'

const DayOffList = lazy(() =>
    import('./components/List').then((m) => ({ default: m.DayOffList }))
)
const DayOffCreatePage = lazy(() =>
    import('./components/Create').then((m) => ({ default: m.DayOffCreatePage }))
)
const DayOffUpdate = lazy(() => import('./components/Update'))
const DetailDayOff = lazy(() =>
    import('./components/Detail').then((m) => ({ default: m.DetailDayOff }))
)
const DayOffHrmModule: RouteObject = {
    path: 'dayoffs',
    element: <DayOffList pageType="hrm" />,
}

const DayOffEmployeeModule: RouteObject = {
    path: 'account/dayoffs',

    children: [
        {
            path: '',
            element: <DayOffList pageType="member" />,
        },
        {
            path: 'new',
            element: <DayOffCreatePage pageType="create" />,
        },
        {
            path: ':id/edit',
            element: <DayOffUpdate />,
        },
    ],
}

const DayOffModule: RouteObject = {
    path: 'dayoffs',
    children: [
        {
            path: ':id',
            element: <DetailDayOff />,
        },
    ],
}

/**
 * The Dayoffs routes, for the host to mount (it adds the errorElement).
 *
 * This is the only way to get them, and it takes the host: so a host cannot
 * mount the routes and forget to register the pieces they read at render time.
 * Registering also adds the `dayoffs` i18n namespace and the module's modals.
 */
export function createDayoffsModule(host: DayoffsHost): RouteObject[] {
    registerDayoffsHost(host)
    host.registerModals(dayoffsModals)
    return [DayOffHrmModule, DayOffEmployeeModule, DayOffModule]
}

export type { DayoffsHost } from './host'
